// Overlapping-avatar "face stack" — e.g. "3 avatars + N" for who's done
// today's devotional, or who's going to an event. Self-contained (doesn't
// import BibleApp.jsx's Avatar, which isn't exported — small per-file
// helpers are the existing convention in this codebase).

function getInitials(name) {
  return (name || '')
    .split(/\s+/).filter(Boolean).slice(0, 2)
    .map(w => w[0].toUpperCase()).join('') || '·'
}

function Face({ url, name, size, overlap }) {
  const sz = { width: size, height: size, borderRadius: '50%', flexShrink: 0 }
  const border = { border: '2px solid var(--white)', marginLeft: overlap ? -size * 0.3 : 0 }
  if (url) {
    return <img src={url} alt="" loading="lazy" style={{ ...sz, ...border, objectFit: 'cover', display: 'block' }}/>
  }
  return (
    <div style={{
      ...sz, ...border,
      background: 'rgba(232,200,122,0.14)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: Math.max(9, Math.round(size * 0.34)),
      fontWeight: 800, color: 'var(--gold-ink)', letterSpacing: '0.02em',
    }}>
      {getInitials(name)}
    </div>
  )
}

// userIds: array of ids to render, in order. profilesById: { [id]: { full_name, avatar_url } }.
export default function FaceStack({ userIds = [], profilesById = {}, max = 3, size = 26 }) {
  if (!userIds.length) return null
  const shown = userIds.slice(0, max)
  const extra = userIds.length - shown.length
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {shown.map((id, i) => {
        const p = profilesById[id]
        return <Face key={id} url={p?.avatar_url} name={p?.full_name} size={size} overlap={i > 0}/>
      })}
      {extra > 0 && (
        <div style={{
          width: size, height: size, borderRadius: '50%', marginLeft: -size * 0.3,
          border: '2px solid var(--white)', background: 'var(--stone)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: Math.max(9, Math.round(size * 0.32)), fontWeight: 800, color: 'var(--white)',
        }}>
          +{extra}
        </div>
      )}
    </div>
  )
}
